import {FORMATS} from '@chatize-ui/constants/formats'
import {POS_PARAM_EXT} from '@chatize-ui/constants/pos-params'

export const isChatExtUrl = (url: string): string | null => {
  const regex = new RegExp(`chat-(?<${POS_PARAM_EXT}>(${FORMATS.join('|')}))$`, 'g')

  for (const match of url.matchAll(regex)) {
    const ext = match.groups[POS_PARAM_EXT]

    if (ext) {
      return ext
    }
  }

  return null
}
